import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield (hash activeTile=this.activeTile)}}",{ moduleName: "discourse/components/tap-tile-grid.hbs" })